module.exports = __webpack_public_path__ + "img/icon_ho_bg.5da43640.png";